import { Validate } from '@dreryk/react-common';
import { Checkbox } from '@dreryk/react-components';

import { patientConsentsAndAuthorizationsTranslationKeys } from '../../../../../translations';
import {
   MedicalDataAccessAuthorizationFormBean,
   MedicalDataAccessAuthorizationFormController,
} from '../MedicalDataAccessAuthorizationModalForm.types';

type DocumentationAccessProps = {
   readonly register: MedicalDataAccessAuthorizationFormController['register'];
};

const validate: Validate<MedicalDataAccessAuthorizationFormBean> = (data, getValue) => {
   if (!data && !getValue('informationAccess')) {
      return patientConsentsAndAuthorizationsTranslationKeys.authorizations.chooseAtLeastOneAuthorization;
   }

   return undefined;
};

const DocumentationAccessField = (props: DocumentationAccessProps): JSX.Element => {
   return (
      <Checkbox
         label={patientConsentsAndAuthorizationsTranslationKeys.authorizations.documentationAccess}
         controller={props.register('documentationAccess', { validate: validate })}
         testId={'documentationAccess'}
      />
   );
};

export { DocumentationAccessField };
